import script from "./ErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorModal.vue?vue&type=style&index=0&id=6fe21314&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe21314"]])

export default __exports__